import * as SwitchPrimitive from '@radix-ui/react-switch';
import type { ReactNode } from 'react';
import { cx } from './cx.ts';

/**
 * Radix switch. On-state uses the deep signal tone (a filled slab of
 * bright signal at this size reads as an alert, not a control).
 */
interface Props {
  readonly checked: boolean;
  readonly onCheckedChange: (checked: boolean) => void;
  readonly label?: ReactNode;
  readonly disabled?: boolean;
  readonly id?: string;
  readonly className?: string;
  readonly testId?: string;
}

export function Switch({ checked, onCheckedChange, label, disabled = false, id, className, testId }: Props): JSX.Element {
  const control = (
    <SwitchPrimitive.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      data-testid={testId}
      className="relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-line bg-active transition-colors duration-120 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal/40 data-[state=checked]:border-signal-deep data-[state=checked]:bg-signal-deep disabled:pointer-events-none disabled:opacity-50"
    >
      <SwitchPrimitive.Thumb className="block h-3.5 w-3.5 translate-x-0.5 rounded-full bg-paper transition-transform duration-120 data-[state=checked]:translate-x-[18px]" />
    </SwitchPrimitive.Root>
  );

  if (label === undefined || label === null) {
    return control;
  }

  return (
    <label className={cx('inline-flex cursor-pointer select-none items-center gap-2 text-body text-paper-mid', disabled && 'cursor-not-allowed opacity-60', className)}>
      {control}
      <span>{label}</span>
    </label>
  );
}
